<cft-holy-grail-grid-sidenav *transloco="let t" [levels]="levels" [level]="t('topic.articlesLabel')" [items]="items">
</cft-holy-grail-grid-sidenav>
